const treatmentHistoryKeys = {
    list: (patientId: string) => ['treatmentHistory', 'list', 'patient', patientId],
  };
  
  export { treatmentHistoryKeys };
  
  